// extracted by mini-css-extract-plugin
module.exports = {"FOOTER":"Footer_FOOTER__2AmdJ","FOOTER__social_icons":"Footer_FOOTER__social_icons__17xYG","FOOTER__payment_icons":"Footer_FOOTER__payment_icons__34wUC"};